import { createIcon } from './create-icon.js';
export default createIcon('player-pause', 'IconPlayerPause', [["rect",{"x":"6","y":"4","width":"4","height":"16","rx":"1.5"}],["rect",{"x":"14","y":"4","width":"4","height":"16","rx":"1.5"}]]);